<template>
  <BusinessSidebar v-if="$route.path.match(/business/)" />
  <OrderSidebar v-else-if="$route.path.match(/orders/)" />
  <SystemSidebar v-else-if="$route.path.match(/system/)" />
  <UserSidebar v-else-if="$route.path.match(/users/)" />
</template>

<script>
const OrderSidebar = () => import('./OrderSidebar.vue');
const UserSidebar = () => import('./UserSidebar.vue');
const BusinessSidebar = () => import('./BusinessSidebar.vue');
const SystemSidebar = () => import('./SystemSidebar.vue');

export default {
  components: {
    OrderSidebar,
    UserSidebar,
    BusinessSidebar,
    SystemSidebar,
  },
};
</script>
